import React from 'react'
import { Link } from 'react-router-dom'
const Tc = () => {
  return (
    <>
    <section className="page-header">
        <div className="page-header-bg"></div>
        <div className="page-header-shape-1"><img src="/Images/page-header-shape-1.png" alt="Loreto Convent School, Delhi Cantt"/></div>
        <div className="container">
        <div className="page-header__inner">
            <ul className="thm-breadcrumb list-unstyled ml-0">
                <li><Link to="/"> Home</Link></li>
                <li> Transfer Certificate   </li>
            </ul>
            <h2>Transfer Certificate  </h2>
        </div>
        </div>
    </section>
    <section className="innerbody">
   <div className="container">
      <div className="col-md-12">
      
      <div className="tcblock">
      <div className="tc">
           <div>
              <div className="formfil">
                  <div className="form-group">
                    <label for="number"><p> Admission No. </p></label>
                    <input type="text" className="form-control"/>
                  </div>
                   <div className="form-group">
                    <label for="number"><p> Student Full Name </p></label>
                    <input type="text" className="form-control"/>
                  </div>
              </div>
              <div className="clr30"></div>
           <input type="button" className="viewdetailsbtn"  value="Submit" />
            </div>
       </div>
        <iframe src='/pdf/TC-Sample.pdf#toolbar=0' width="100%" height="500"></iframe>
 </div>
      </div>
</div>
</section>
   </>
  )
}

export default Tc